import React, { useEffect, useState } from 'react'
import './Schedule.css'
import Calendar from './adminComponents/Calendar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import fetchData from '../../function/fetchData'
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import AllDriversButtons from './adminComponents/AllDriversButtons'
import CloseButton from 'react-bootstrap/CloseButton';
import Billing from './adminComponents/Billing';
import Toast from './adminComponents/Toast';
import Button from 'react-bootstrap/Button';
import ModalInvoicesHistory from './adminComponents/ModalInvoicesHistory'
import BillingForNoDriver from './adminComponents/BillingForNoDriver';
import DriverEdit from './adminComponents/DriverEdit';


const Schedule = ({setShowSchedule, server}) => {
    const [date, setDate] = useState(null)
    const [dataFromServer, setDataFromServer] = useState(null)
    const [token, setToken] = useState(null)
    const [selectedDriverId, setSelectedDriverId] = useState(null)
    const navigate = useNavigate();
    const [modalShowBilling, setShowModalBilling] = useState(false)
    const [modalShowBillingForNoDriver, setShowModalBillingForNoDriver] = useState(false)
    const [selectedDriverSchedule, setSelectedDriverSchedule] = useState(null)
    const [modalInvoiceList, setModalInvoiceList] = useState(false)
    const [driverEditModal, setDriverEditModal] = useState(false)

    // Položky faktury
    const [rows, setRows] = useState([]);
    // Toast
    const [showToast , setShowToast] = useState(false)
    const [toastText, setToastText] = useState(null)

    // Má data v localstorage?
    useEffect( () => {
        const data = localStorage.getItem('driverToken');
        if(data) {
          setToken(data)
        }
    }, [])

    const fetchDataFromServer = () => {
        fetchData(server + "api2/adminScheduleController.php", {token: token, action: "GET" , date: date})
            .then( (res) => {
                if(res.status === "OK"){
                    console.log(res)
                    setDataFromServer(res.payload)
                } else {
                    alert('chyba spojení, zkuste to později')
                }
                
            } )

    }


    // Získá data
    useEffect( ()=> {
        if(token){        
            fetchDataFromServer()
        }

    }, [token, date])

    // Vyfiltltruje uřivatele
    useEffect( ()=> {
        setShowToast(false)
        if(selectedDriverId){
            const result = dataFromServer?.schedule.filter( one => {
                return parseInt(one.payed_driver_id) === parseInt(selectedDriverId)
            })
            setShowModalBilling(true)
            setSelectedDriverSchedule(result)
        
        }


    }, [selectedDriverId])

    const closeBilling = () => {
        setShowModalBilling(false)
        setSelectedDriverId(null)
        setSelectedDriverSchedule(null)
        setRows([])
        setShowModalBillingForNoDriver(false)
    }

    if(!dataFromServer){
        return <p>načítám</p>
    }


    return (
        <div>
            <Toast toastText={toastText}  showToast={showToast} setShowToast={setShowToast} />
        
            {modalShowBilling && <Billing 
                onShow={modalShowBilling} 
                onHide={closeBilling} 
                selectedDriverSchedule={selectedDriverSchedule}
                drivers={dataFromServer.drivers}
                server={server}
                token={token}
                fetchDataFromServer={fetchDataFromServer}
                setSelectedDriverSchedule={setSelectedDriverSchedule}
                date={date}
                rows={rows}
                setRows={setRows}
                selectedDriverId={selectedDriverId}
            /> }

            {modalShowBillingForNoDriver && <BillingForNoDriver 
                onShow={modalShowBillingForNoDriver} 
                onHide={closeBilling} 
                selectedDriverSchedule={selectedDriverSchedule}
                drivers={dataFromServer.drivers}
                server={server}
                token={token}
                fetchDataFromServer={fetchDataFromServer}
                setSelectedDriverSchedule={setSelectedDriverSchedule}
                date={date}
                rows={rows}
                setRows={setRows}
                selectedDriverId={selectedDriverId}
            /> }
            {driverEditModal && <DriverEdit onShow={driverEditModal} onHide={()=> setDriverEditModal(false)} drivers={dataFromServer.drivers} fetchDataFromServer={fetchDataFromServer} server={server} token={token}/> }
            {modalInvoiceList && <ModalInvoicesHistory onShow={modalInvoiceList} onHide={()=> setModalInvoiceList(false)} server={server} token={token}/> }
         

            <div className='top'>
                <div style={{display:'flex', gap: 10, alignItems: 'center'}}>
                Rozvrh šichet
                <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <FontAwesomeIcon icon={faMoneyBill} />
                        Poslat vyúčtování řidiči
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    <AllDriversButtons 
                            listOfDrivers={dataFromServer.drivers}  
                            selectedDriverId={selectedDriverId} 
                            setSelectedDriverId={setSelectedDriverId}
                        />
                    </Dropdown.Menu>
                </Dropdown>

                <Button variant="light" onClick={()=>setModalInvoiceList(true)}>Historie fakturace</Button>
                <Button variant="light" onClick={()=>setShowModalBillingForNoDriver(true)}>Poslat fakturu firmě</Button>
                <Button variant="light" onClick={()=>setDriverEditModal(true)}>Hodnocení řidičů</Button>

                </div>
               
                <CloseButton onClick={()=> navigate('/admin') }/>

            </div>
        
            <Calendar dataFromServer={dataFromServer} setDate={setDate} fetchDataFromServer={fetchDataFromServer} token={token} server={server}/>
        </div>
  )
}

export default Schedule


